import humanizeString from "string-humanize";
import he from "he";

export function humanize(str) {
  let result = humanizeString(str);

  // handle some special cases
  if (str === "isle_of_man") {
    result = "Isle of Man";
  } else if (str === "iom_1931_act_company_limited_by_shares") {
    result = "1931 Act Company Limited by Shares";
  }

  return result;
}

export function slice(str, beginIndex, endIndex) {
  if (str) {
    return str.slice(beginIndex, endIndex);
  } else {
    return "";
  }
}

export function decode(str, options) {
  return he.decode(str, options);
}
